function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var module;
// LICENSE_CODE ZON
'use strict'; /*jslint node:true, es6:true, react:true*/

var is_node = typeof module == 'object' && module.exports;
if (is_node) ;else ;
define(['react', '/util/url.js', '/www/hola/pub/ui/trustpilot_link.tsx', '/www/hola/pub/lib/screen_util.ts', '/www/hola/pub/ui/install_util.js', '/www/hola/pub/ui/img_url.ts', 'hola_opt', '/util/etask.js', '/util/escape.js', 'classnames', 'zutil', '/svc/account/pub/membership.js', '/www/hola/pub/plus_util.js', '/www/hola/pub/eec.js', '/www/hola/pub/gtm.ts', '/util/zerr.js', '/util/hash.js', '/www/hola/pub/plus_ui.js', '/www/hola/pub/install_util.js', '/www/hola/pub/util.js', '/util/country.js', 'react-router-dom', '/www/hola/pub/pages_dict.js', '/www/hola/pub/plans_util.js', 'react-i18next', '/www/hola/pub/experiment_init', '/www/hola/pub/experiment_util', '/www/hola/pub/ui/navbar/navbar_logo.js', '/www/hola/pub/plus/plans.js', '/www/hola/pub/lib/slider.tsx', '/www/hola/pub/settings_ctx.tsx', '/www/hola/pub/plus/payment_progress.tsx', '/www/hola/pub/lib/tooltip.js', '/www/hola/pub/plus/currency_select.tsx', '/www/hola/pub/lib/use_qs.ts', '/www/hola/pub/plus/plan_banner.tsx', '/www/hola/pub/ui/browser/br_footer.tsx',
// imports only
'/www/hola/pub/css/join_n.less'], (React, zurl, {
  Trustpilot_link
}, {
  get_width
}, {
  _start_install
}, {
  img_url
}, hopt, etask, zescape, cn, _, membership, plus_util, eec, gtm, zerr, zhash, plus_ui, iutil, www_util, zcountry, RRD, pages_dict, plans_util, react_i18n, experiment_init, experiment_util, {
  Navbar_logo
}, {
  Plus_plans
}, {
  Slider
}, {
  Settings_context
}, {
  Payment_progress
}, {
  Tooltip
}, {
  Currency_select
}, {
  use_qs_with_set
}, {
  Plan_banner
}, {
  Br_footer
}) => {
  var useState = React.useState,
    useEffect = React.useEffect,
    Fragment = React.Fragment,
    useContext = React.useContext;
  var useLocation = RRD.useLocation;
  var T = react_i18n.Trans,
    useTranslation = react_i18n.useTranslation;
  experiment_init = experiment_init.default;
  experiment_util = experiment_util.default;
  var E = {};
  var qs_o = () => zurl.qs_parse(location.search.substr(1), {
    safe: true
  });
  var N = 2;
  var ref = qs_o().ref || '';
  var perr = opt => plus_util.perr(_objectSpread(_objectSpread({}, opt), {}, {
    id: opt.id.replace(/^www_join1/, `www_join${N}`)
  }));
  var perr_hashes = {};
  var perr_once = opt => {
    var hash = '' + zhash.hash_string(zerr.json(opt));
    if (perr_hashes[hash]) return;
    perr_hashes[hash] = true;
    return perr(opt);
  };
  var plan_to_url = (plan, opt = {}) => plan && (opt.ultra ? plan.id : plan.period.toLowerCase().replace(' ', ''));
  var get_url_plan = params => {
    params = params || qs_o();
    if (plans_util.get_coupon_flow() == 'coupon') return {
      id: 'coupon',
      price: 0
    };
    var plan, period;
    if (params.plan_id) {
      plan = plans_util.get_plans_info_obj({
        id: params.plan_id
      });
      if (plan) return plans_util.get_discount_plan(plan) || plan;
      perr_once({
        id: 'www_join1_plan_not_found',
        info: params
      });
    }
    if (!plan && params.plan) period = plus_util.parse_plan_period(params.plan);
    if (!period && params.plan_id) period = plus_util.parse_plan_period(params.plan_id);
    if (period) {
      plan = plans_util.get_plans_info_obj({
        period
      });
      plan = plans_util.get_discount_plan(plan) || plan;
      if (!plan) perr_once({
        id: 'www_join1_plan_not_found',
        info: params
      });
      return plan;
    }
  };
  E.get_url_plan = get_url_plan;
  var get_url_plan_or_default = (def, params) => {
    var plan = get_url_plan(params);
    if (plan) return plan;
    return get_url_plan(def);
  };
  E.get_url_plan_or_default = get_url_plan_or_default;
  var Free_period_label = ({
    plan,
    is_payment_slide
  }) => {
    var _ref = plan || {},
      free_period = _ref.free_period,
      plan_id = _ref.id;
    var _ref2 = {
        '1 M': {
          src: 'plus/free_for_month.png'
        }
      }[free_period] || {},
      src = _ref2.src;
    var _useState = useState(src),
      _useState2 = _slicedToArray(_useState, 2),
      img_src = _useState2[0],
      set_img_src = _useState2[1];
    var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      show_label = _useState4[0],
      set_show_label = _useState4[1];
    useEffect(() => {
      if (plan_id) set_img_src(src);
    }, [src, plan_id]);
    useEffect(() => {
      set_show_label(img_src && is_payment_slide);
    }, [img_src, is_payment_slide]);
    return img_src ? /*#__PURE__*/React.createElement("img", {
      src: img_url(img_src),
      alt: "free_period",
      className: cn('free_period_label label_appear', 'lazyload', !show_label && 'label_hidden')
    }) : null;
  };
  var Header = () => {
    if (pages_dict.is_uninstall_page()) {
      return /*#__PURE__*/React.createElement("div", {
        className: "header uninstall"
      }, /*#__PURE__*/React.createElement("p", null, "Special offer:"), /*#__PURE__*/React.createElement("h2", null, /*#__PURE__*/React.createElement("span", null, "Save 47% "), "on Hola Premium"));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "header"
    }, /*#__PURE__*/React.createElement("h2", null, /*#__PURE__*/React.createElement(T, null, "Choose Your Plan")), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement(T, null, "Unlimited super fast browsing"))));
  };
  var Select_plan = props => {
    var downloads = props.downloads,
      plans = props.plans,
      set_plan = props.set_plan,
      country = props.country,
      set_currency = props.set_currency,
      cls = props.cls,
      only_right_part = props.only_right_part;
    var _useContext = useContext(Settings_context),
      theme = _useContext.theme;
    var _useLocation = useLocation(),
      pathname = _useLocation.pathname;
    plans = plans.slice();
    if (plans.length == 0) return /*#__PURE__*/React.createElement(Fragment, null);
    var _plans_util$get_speci = plans_util.get_special_plans(plans),
      best = _plans_util$get_speci.best;
    var _plus_util$get_curren = plus_util.get_currency_o(props.currency, best),
      currency = _plus_util$get_curren.currency,
      currencies = _plus_util$get_curren.currencies;
    var _membership$get_price = membership.get_price_plan(best, currency),
      renewal_price = _membership$get_price.renewal_price;
    var annual_promo = pages_dict.is_uninstall_page() || pages_dict.is_annual_promo();
    var bogof_promo = pages_dict.is_bogof_promo();
    var is_afflp_ni = (qs_o().ref || '').indexOf('afflp_ni') > -1;
    var is_afflp_annual = (qs_o().ref || '').indexOf('afflp_annual') > -1;
    var is_new_tabs = pathname == '/premium' && (is_afflp_ni || is_afflp_annual);
    var _qs_o = qs_o(),
      layout = _qs_o.layout;
    var condensed = layout == 'condensed';
    return /*#__PURE__*/React.createElement("div", {
      className: cn('select-plan', cls)
    }, currencies.length > 1 && /*#__PURE__*/React.createElement(Currency_select, {
      only_right_part: only_right_part,
      currency: currency,
      on_change: set_currency,
      currencies: currencies,
      cls: cn('currency_select_float_right', condensed && 'condensed_currency_select_float_right')
    }), !only_right_part && /*#__PURE__*/React.createElement(Header, {
      downloads: downloads,
      country: country
    }), /*#__PURE__*/React.createElement("div", {
      className: "container"
    }, is_new_tabs ? /*#__PURE__*/React.createElement(plus_ui.Plus_plans_tabs, {
      plans: plans,
      set_plan: set_plan,
      best: best,
      currency: currency
    }) : /*#__PURE__*/React.createElement(Plus_plans, {
      plans: plans,
      best: best,
      N: N,
      bogof: bogof_promo,
      set_plan: set_plan,
      short: true,
      currency: currency
    }), /*#__PURE__*/React.createElement("div", {
      className: "money-back"
    }, /*#__PURE__*/React.createElement(T, {
      i18nKey: "30_day_moneyback_text.join_n",
      components: {
        span: /*#__PURE__*/React.createElement("span", {
          className: cn(theme.P, theme.xs)
        }),
        b: /*#__PURE__*/React.createElement("b", null),
        strong: /*#__PURE__*/React.createElement("strong", null),
        a: /*#__PURE__*/React.createElement("a", {
          href: "/faq#refund-policy",
          target: "_blank",
          rel: "noopener noreferrer"
        })
      }
    })), annual_promo && /*#__PURE__*/React.createElement("div", {
      className: "renewal"
    }, /*#__PURE__*/React.createElement("p", {
      className: theme.p2
    }, /*#__PURE__*/React.createElement("sup", null, "*"), "After the initial period, you will be charged ", zcountry.format_price(currency, renewal_price), " annual service fee until you cancel the subscription")), bogof_promo && /*#__PURE__*/React.createElement("div", {
      className: "renewal"
    }, /*#__PURE__*/React.createElement("p", {
      className: theme.p2
    }, "* After the initial 2 months period, you will be charged ", zcountry.format_price(currency, best.price), " monthly service fee until you cancel the subscription"))));
  };
  var Slide_select_plan = ({
    cls,
    cmp_props
  }) => {
    return /*#__PURE__*/React.createElement(Select_plan, _extends({
      key: "select_plan",
      cls: cls
    }, cmp_props));
  };
  var Coupon_slide = ({
    cls,
    cmp_props
  }) => {
    var email = cmp_props.email,
      coupon_flow = cmp_props.coupon_flow,
      slide = cmp_props.slide,
      go_back = cmp_props.go_back,
      show_back = cmp_props.show_back,
      on_continue = cmp_props.on_continue;
    return /*#__PURE__*/React.createElement("div", {
      key: "coupon",
      className: cls
    }, !!show_back && /*#__PURE__*/React.createElement("a", {
      className: "back-button",
      onClick: go_back
    }, "Back"), /*#__PURE__*/React.createElement(plus_ui.Step_redeem, {
      email: email,
      slide_active: slide == 'coupon',
      hide_agree: coupon_flow != 'coupon',
      on_continue: coupon_flow != 'coupon' && on_continue
    }));
  };
  var Payment_slide = ({
    cls,
    cmp_props
  }) => {
    var slide = cmp_props.slide,
      plan = cmp_props.plan;
    var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      method_chosen = _useState6[0],
      set_method_chosen = _useState6[1];
    var payment_step_cls = cn('container payment-container', method_chosen && 'method-chosen');
    return /*#__PURE__*/React.createElement("div", {
      key: "payment",
      className: cls
    }, /*#__PURE__*/React.createElement("div", {
      className: payment_step_cls
    }, plan && /*#__PURE__*/React.createElement(plus_ui.Step_payment, _extends({
      expand: "cc",
      selected_plan: plan,
      slide_active: slide == 'payment',
      set_method_chosen: set_method_chosen,
      method_chosen: method_chosen
    }, cmp_props))));
  };
  var Slides = props => {
    var user = props.user,
      user_email = props.user_email,
      load_user = props.load_user,
      plan = props.plan,
      api = props.api,
      set_api = props.set_api,
      api_loaded = props.api_loaded,
      go_back = props.go_back,
      on_continue = props.on_continue,
      slide = props.slide,
      set_plan = props.set_plan,
      downloads = props.downloads,
      currency = props.currency,
      country = props.country,
      coupon = props.coupon,
      set_currency = props.set_currency,
      script_err = props.script_err,
      set_coupon = props.set_coupon,
      on_script_load_err = props.on_script_load_err,
      only_right_part = props.only_right_part,
      on_method_tab_change = props.on_method_tab_change,
      on_vat_obj_change = props.on_vat_obj_change;
    var _useLocation2 = useLocation(),
      pathname = _useLocation2.pathname;
    var _useState7 = useState({
        email: user_email,
        email_error: null
      }),
      _useState8 = _slicedToArray(_useState7, 2),
      state = _useState8[0],
      set_state = _useState8[1];
    var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      plans = _useState10[0],
      set_plans = _useState10[1];
    useEffect(() => {
      perr({
        id: `www_join1_${slide}_show`
      });
    }, [slide]);
    var plans_version = plans_util.use_plans();
    useEffect(() => {
      var plans_info = _.values(plans_util.get_plans_info(plans_util.get_plan_ids()));
      set_plans(plans_info);
      var _plans_util$get_speci2 = plans_util.get_special_plans(plans_info || []),
        best = _plans_util$get_speci2.best;
      var currency_o = plus_util.get_currency_o(currency, best);
      set_currency(currency_o.currency);
    }, [pathname, plans_version]);
    var set_email = email => set_state(_st => {
      email = `${email || ''}`.trim();
      return _objectSpread(_objectSpread({}, _st), {}, {
        email,
        email_error: null
      });
    });
    var set_email_err = email_error => set_state(_st => {
      return _objectSpread(_objectSpread({}, _st), {}, {
        email_error
      });
    });
    var email = state.email,
      email_error = state.email_error;
    var check_email = _email => {
      if ((_email || email) && !user) {
        var err = plus_util.validate_email_syntax(_email || email);
        if (!err) return true;
        set_email_err(err);
        return false;
      }
      return true;
    };
    var coupon_flow = plans_util.get_coupon_flow();
    var show_back = slide == 'account' && !coupon_flow || slide == 'payment' && (!coupon_flow || !user);
    var steps_cls = cn('steps');
    var cmp_props = {
      downloads,
      plan,
      plans,
      set_plan,
      country,
      set_coupon,
      coupon,
      currency,
      set_currency,
      user,
      slide,
      load_user,
      email_error,
      set_email_err,
      set_email,
      email,
      on_continue,
      check_email,
      coupon_flow,
      show_back,
      go_back,
      script_err,
      api,
      user_email,
      api_loaded,
      set_api,
      set_plans,
      on_script_load_err,
      only_right_part,
      on_method_tab_change,
      on_vat_obj_change
    };
    return /*#__PURE__*/React.createElement("div", {
      className: steps_cls
    }, /*#__PURE__*/React.createElement(Slider, {
      active: slide,
      items: [{
        id: 'select_plan',
        content: Slide_select_plan
      }, {
        id: 'coupon',
        content: !!coupon_flow && Coupon_slide
      }, {
        id: 'payment',
        content: coupon_flow != 'coupon' && Payment_slide
      }],
      timeout: 200,
      cmp_props: cmp_props,
      distance: 150,
      on_end_animation: () => window.scrollTo(0, 0)
    }));
  };
  var Advantages = ({
    type,
    plan
  }) => {
    var _useTranslation = useTranslation(),
      t = _useTranslation.t;
    var _useContext2 = useContext(Settings_context),
      theme = _useContext2.theme;
    var platforms = img_url('platforms/platforms_list.svg');
    if (get_width() < 768) platforms = img_url('platforms/platforms_list_mobile.svg');
    return /*#__PURE__*/React.createElement("ul", {
      className: `advantages ${type}`
    }, /*#__PURE__*/React.createElement("li", {
      className: "unblock"
    }, /*#__PURE__*/React.createElement("p", {
      className: theme.p2
    }, /*#__PURE__*/React.createElement(T, null, type == 'free' && 'Unblock 99.9% of websites', type == 'plus' && 'Access more global content', type == 'ultra' && (plan ? /*#__PURE__*/React.createElement("b", null, "Everything in Premium") : 'Access more global content')))), /*#__PURE__*/React.createElement("li", {
      className: "devices"
    }, /*#__PURE__*/React.createElement("p", {
      className: theme.p2
    }, t('connect_devices', {
      count: type == 'ultra' ? 20 : type == 'plus' ? 10 : 3
    }))), /*#__PURE__*/React.createElement("li", {
      className: "streaming"
    }, /*#__PURE__*/React.createElement("p", {
      className: theme.p2
    }, /*#__PURE__*/React.createElement(T, null, type == 'ultra' ? '4K' : type == 'plus' ? 'HD' : 'SD', " Video streaming"))), /*#__PURE__*/React.createElement("li", {
      className: "servers"
    }, /*#__PURE__*/React.createElement("p", {
      className: theme.p2
    }, t(`${type == 'ultra' ? 'Ultra fast' : 'Super fast'} servers`))), type == 'free' && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("p", {
      className: theme.p2
    }, "Free limited browsing time"))), (type == 'plus' || type == 'ultra' && !plan) && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("li", {
      className: "vpn_time"
    }, /*#__PURE__*/React.createElement("p", {
      className: theme.p2
    }, /*#__PURE__*/React.createElement(T, null, "Unlimited usage")))), (type == 'ultra' || type == 'plus') && /*#__PURE__*/React.createElement("li", {
      className: "platforms"
    }, /*#__PURE__*/React.createElement("p", {
      className: theme.p2
    }, "Apps across all of your ", /*#__PURE__*/React.createElement(Tooltip, {
      content: /*#__PURE__*/React.createElement("img", {
        alt: "platforms",
        src: platforms,
        className: "lazyload"
      }),
      cls_cn: "platforms-tooltip"
    }, /*#__PURE__*/React.createElement("span", {
      className: cn(theme.primary, 'platforms-tooltip-text')
    }, "favorite platforms")))), (type == 'ultra' || type == 'plus') && /*#__PURE__*/React.createElement("li", {
      className: "smart_dns"
    }, /*#__PURE__*/React.createElement("p", {
      className: theme.p2
    }, "Smart DNS for TVs, Gaming Consoles")), type == 'ultra' && /*#__PURE__*/React.createElement("li", {
      className: "support"
    }, /*#__PURE__*/React.createElement("p", {
      className: theme.p2
    }, "24/7 Real person support")));
  };
  E.Advantages = Advantages;
  var start_install = (ctx, agree) => {
    _start_install({
      ctx,
      agree,
      install_src: `join${N}`,
      skip: {
        choose_plan: true
      }
    }, () => perr({
      id: 'www_join1_start_install'
    }));
  };
  var install_ctx_et, install_ctx;
  var init_install_ctx = () => {
    if (install_ctx) return;
    return install_ctx_et || etask(function* () {
      install_ctx_et = this;
      this.finally(() => install_ctx_et = null);
      install_ctx = yield iutil.init_ctx({
        install_src: `join${N}`
      });
    });
  };
  var Summary_info = ({
    plan,
    currency
  }) => {
    var _useContext3 = useContext(Settings_context),
      theme = _useContext3.theme;
    var _useLocation3 = useLocation(),
      pathname = _useLocation3.pathname;
    var type = pathname == '/ultra' ? 'Ultra' : 'Premium';
    var price_o = membership.get_price_plan(plan, currency);
    var regular_price = price_o.regular_price,
      price = price_o.price,
      discount_percent = price_o.discount_percent;
    var save_money = regular_price - price;
    return /*#__PURE__*/React.createElement("div", {
      className: cn('payment_summary_info')
    }, /*#__PURE__*/React.createElement("div", {
      className: "payment_summary_row"
    }, /*#__PURE__*/React.createElement("p", {
      className: cn(theme.xs, theme.grey_2)
    }, "Hola ", type), /*#__PURE__*/React.createElement("p", {
      className: cn(theme.xs, theme.grey_2)
    }, zcountry.format_price(currency, regular_price))), /*#__PURE__*/React.createElement("div", {
      className: "payment_summary_row"
    }, /*#__PURE__*/React.createElement("p", {
      className: cn(theme.xs, theme.grey_2, 'payment_flex_discount')
    }, "Discount ", discount_percent > 0 ? /*#__PURE__*/React.createElement("span", {
      className: "payment_discount_label"
    }, discount_percent, "% saving") : ''), /*#__PURE__*/React.createElement("p", {
      className: cn(theme.xs, theme.grey_2)
    }, zcountry.format_price(currency, save_money > 0 ? -save_money : 0))), /*#__PURE__*/React.createElement("div", {
      className: "payment_summary_line"
    }), /*#__PURE__*/React.createElement("div", {
      className: "payment_summary_row"
    }, /*#__PURE__*/React.createElement("p", {
      className: cn(theme.xs, theme.grey_2)
    }, /*#__PURE__*/React.createElement("b", null, "Order total")), /*#__PURE__*/React.createElement("p", {
      className: cn(theme.xs, theme.grey_2)
    }, zcountry.format_price(currency, price))));
  };
  var Payment = ({
    opt,
    only_right_part
  }) => {
    var _useContext4 = useContext(Settings_context),
      theme = _useContext4.theme;
    var _useLocation4 = useLocation(),
      pathname = _useLocation4.pathname;
    var type = pathname == '/ultra' ? 'ultra' : 'plus';
    plans_util.use_plans();
    var plans = _.values(plans_util.get_plans_info(plans_util.get_plan_ids()));
    var best = _.min_by(plans, p => p.month_price);
    var on_click_select = () => {
      if (opt.slide != 'select_plan') opt.go_back();
    };
    var on_click_payment = () => {
      if (opt.slide != 'payment') opt.set_plan(best);
    };
    var plan = opt.plan;
    var new_uninstall = pages_dict.is_uninstall_page();
    var refund_page = ref == 'refund' || ref == 'refund_special_big_offer' || ref == 'refund_special_cta';
    var is_condensed = qs_o().layout == 'condensed' && 'condensed';
    return /*#__PURE__*/React.createElement("div", {
      className: cn(is_condensed ? 'condensed' : theme.container, 'payment')
    }, !is_condensed && /*#__PURE__*/React.createElement(Payment_progress, {
      slide: opt.slide,
      on_click_select: on_click_select,
      on_click_payment: on_click_payment
    }), /*#__PURE__*/React.createElement("section", {
      className: cn('payment-section', only_right_part && 'only_right_part')
    }, !only_right_part && !is_condensed && /*#__PURE__*/React.createElement("div", {
      className: "payment-info"
    }, new_uninstall ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("h3", null, "Seems you are not happy with our free version\u2026", /*#__PURE__*/React.createElement("br", null), "Try Hola Premium!")) : refund_page ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("p", {
      className: "refund-text"
    }, /*#__PURE__*/React.createElement("span", null, "Don't worry! "), "After confirming the payment, we will process the ", /*#__PURE__*/React.createElement("b", null, "refund for your previous purchase"), " and you will receive it in the next 5-7 business days.")) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement(T, null, "Experience the full power of Hola")), /*#__PURE__*/React.createElement("b", {
      className: theme.P
    }, /*#__PURE__*/React.createElement(T, {
      i18nKey: "get_in_join"
    }), " ", type == 'ultra' ? 'Ultra' : 'Premium')), plan && opt.currency && opt.slide == 'payment' && /*#__PURE__*/React.createElement(Summary_info, opt), /*#__PURE__*/React.createElement(Advantages, {
      type: type
    }), /*#__PURE__*/React.createElement(Trustpilot_link, null), plan && opt.slide == 'payment' && /*#__PURE__*/React.createElement(Plan_banner, {
      plan_id: plan.id
    })), /*#__PURE__*/React.createElement("div", {
      className: "payment-steps"
    }, /*#__PURE__*/React.createElement(Slides, _extends({}, opt, {
      only_right_part: only_right_part
    })))), /*#__PURE__*/React.createElement(Free_period_label, {
      plan: plan,
      is_payment_slide: opt.slide === 'payment'
    }));
  };
  E.Root = ({
    users_number,
    user_country,
    only_right_part,
    goto
  }) => {
    if (goto) console.log(goto);
    var _useContext5 = useContext(Settings_context),
      theme = _useContext5.theme;
    var _useState11 = useState({}),
      _useState12 = _slicedToArray(_useState11, 2),
      script_err = _useState12[0],
      set_script_err = _useState12[1];
    var _useLocation5 = useLocation(),
      pathname = _useLocation5.pathname;
    var plan = get_url_plan();
    var version = plans_util.use_plans();
    var coupon_flow = plans_util.get_coupon_flow();
    var _useState13 = useState({
        user: null,
        api: plus_util.api,
        slide: plan ? coupon_flow ? 'coupon' : 'payment' : 'select_plan',
        plan_id: plan && plan.id,
        currency: hopt.user_currency,
        provider: undefined,
        vat_obj: undefined
      }),
      _useState14 = _slicedToArray(_useState13, 2),
      state = _useState14[0],
      set_state = _useState14[1];
    useEffect(() => {
      var plan2 = get_url_plan();
      if (plan2 && state.plan_id != plan2.id) set_state(v => _objectSpread(_objectSpread({}, v), {}, {
        plan_id: plan2.id
      }));
    }, [version, state.plan_id]);
    var api = state.api,
      user = state.user,
      api_loaded = state.api_loaded;
    var _use_qs_with_set = use_qs_with_set(),
      set_url_params = _use_qs_with_set.set_qs;
    var load_user = force => etask(function* () {
      var _user = yield plus_util.login_get_user(force);
      var coupon = state.coupon;
      var new_state = {
        user: _user,
        api: plus_util.api,
        api_loaded: true
      };
      if (_user && _user.coupon && _user.coupon.type && (!coupon_flow || coupon_flow == _user.coupon.type)) {
        new_state.coupon = coupon = _user.coupon._id;
        if (_user.coupon.currency) new_state.currency = _user.coupon.currency;
        if (coupon_flow == 'promo_plan') {
          plans_util.set_fixed_plan_ids(['promo_y1', 'promo_y3']);
          if (ref && !ref.includes(_user.coupon.affiliate)) set_url_params({
            ref: _user.coupon.affiliate + ref
          });
        }
      }
      new_state.slide = !get_url_plan() ? 'select_plan' : coupon_flow && !coupon ? 'coupon' : 'payment';
      set_state(_state => _objectSpread(_objectSpread({}, _state), new_state));
      return _user;
    });
    var on_qs_change = () => {
      var _plan = get_url_plan();
      var plan_id = _plan && _plan.id;
      set_state(_state => _objectSpread(_objectSpread({}, _state), {}, {
        slide: !plan_id ? 'select_plan' : coupon_flow && !_state.coupon ? 'coupon' : 'payment',
        plan_id: plan_id || _state.plan_id
      }));
    };
    var on_method_tab_change = (method, provider) => {
      set_state(s => _objectSpread(_objectSpread({}, s), {}, {
        provider
      }));
    };
    var on_vat_obj_change = vat_obj => {
      set_state(s => _objectSpread(_objectSpread({}, s), {}, {
        vat_obj
      }));
    };
    var checkout_redirect = () => {
      // XXX dmitriiz: do nothing, there was code for "old layout"
    };
    var on_script_load_err = ev => {
      var src = _.get(ev, 'target.src') || '';
      var match = src.match(/(2pay\.js|bluesnap\.js|js\.stripe\.com|paypal\.com\/sdk\/js|pay\.google\.com)/);
      perr({
        id: 'www_premium_payment_script_load_err',
        info: {
          src
        }
      });
      if (match) set_script_err(errs => _objectSpread(_objectSpread({}, errs), {}, {
        [match[1]]: true
      }));
    };
    useEffect(() => {
      checkout_redirect();
      window.addEventListener('popstate', on_qs_change);
      return () => window.removeEventListener('popstate', on_qs_change);
    }, [state]);
    useEffect(() => {
      document.addEventListener('click', event => {
        var _www_util$get_click_d = www_util.get_click_data(event.target),
          click_id = _www_util$get_click_d.id,
          info = _www_util$get_click_d.info;
        if (click_id) www_util.perr({
          id: `www_join${N}_click_${click_id}`,
          info
        });
      });
      plus_util.set_ppc_cookie();
      var plans_info = plans_util.get_plans_info(plans_util.get_plan_ids());
      var plans = Object.keys(plans_info).map(key => {
        var _plans_info$key = plans_info[key],
          id = _plans_info$key.id,
          name = _plans_info$key.name,
          price = _plans_info$key.price;
        return {
          id,
          name,
          price,
          category: 'vpn-b2c',
          list: 'Plus page plans'
        };
      });
      eec.view_item_list(plans);
      etask(function* () {
        var _user = yield load_user();
        var page = pathname.slice(1).replace('/', '_');
        var info = {
          login: _user && _user.hola_uid,
          template: `join${N}`
        };
        perr({
          id: 'www_premium_visit',
          info
        });
        perr({
          id: `www_premium_${page}_visit`,
          info
        });
        if (plans_util.get_plan_ids().includes('free')) yield init_install_ctx();
        yield plus_ui.init(api, on_script_load_err);
      });
    }, []);
    plan = plans_util.get_plans_info_obj({
      id: state.plan_id
    });
    if (state.plan_id && !plan) {
      set_url_params({
        plan_id: null,
        plan: null
      });
      state.plan_id = null;
      on_qs_change();
    }
    var opt = {
      plan,
      slide: state.slide,
      coupon: state.coupon,
      user,
      provider: state.provider,
      vat_obj: state.vat_obj,
      currency: state.currency,
      set_currency: value => set_state(_state => _objectSpread(_objectSpread({}, _state), {}, {
        currency: value ? value.toUpperCase() : 'USD'
      })),
      user_email: _.get(user, 'emails[0].value'),
      country: (user_country || '').toLowerCase(),
      load_user,
      api,
      api_loaded,
      script_err,
      on_script_load_err,
      downloads: users_number,
      set_coupon: code => {
        set_state(v => _objectSpread(_objectSpread({}, v), {}, {
          coupon: code
        }));
      },
      set_plan: (_plan, _opt = {}) => {
        _plan = plans_util.get_discount_plan(_plan) || _plan;
        plans_util.set_plan_opt(_opt);
        perr({
          id: `www_join1_plan_click_${_plan.id}`
        });
        if (_plan.id == 'free') {
          etask(function* () {
            yield init_install_ctx();
            if (iutil.need_choose_plan(install_ctx)) perr({
              id: 'www_join1_agree_show'
            });else start_install(install_ctx);
          });
          return;
        }
        plus_ui.start_checkout();
        gtm.push({
          event: 'choose_plan',
          id: _plan.id
        });
        set_url_params({
          plan: plan_to_url(_plan, _opt)
        });
        on_qs_change();
      },
      go_back: () => {
        perr({
          id: 'www_join1_back_click'
        });
        set_url_params({
          plan_id: null,
          plan: null
        });
        on_qs_change();
      },
      set_api: change => set_state(_state => {
        plus_util.api = _objectSpread(_objectSpread({}, plus_util.api), change);
        return _objectSpread(_objectSpread({}, _state), {}, {
          api: plus_util.api
        });
      }),
      on_continue: _opt => {
        perr({
          id: 'www_join1_continue_click'
        });
        var next_slide = 'payment';
        if (state.slide == 'account' && coupon_flow) next_slide = 'coupon';
        set_state(_state => _objectSpread(_objectSpread(_objectSpread({}, _state), _opt), {}, {
          slide: next_slide
        }));
      },
      on_method_tab_change,
      on_vat_obj_change
    };
    var _ref3 = plan && membership.get_price_plan(plan, state.currency) || {},
      discount_percent = _ref3.discount_percent;
    var bf_conf = hopt.www_hola.black_friday_badge_on_checkout || {};
    var cls = cn(`join_page join${N} plus_layout2`, theme.root, {
      uninstall_page: pages_dict.is_uninstall_page(),
      refund_page: ref == 'refund' || ref == 'refund_special_big_offer' || ref == 'refund_special_cta',
      black_friday_badge: bf_conf && bf_conf.enabled && (!bf_conf.only_for_ext || +!qs_o().bext),
      plan_selected: plan,
      only_right_part_root: only_right_part
    }, plan && `plan_period_` + plan.period.toLowerCase().replace(' ', ''), discount_percent && 'plan_discount_percent_' + discount_percent);
    return /*#__PURE__*/React.createElement("div", {
      className: cls
    }, !only_right_part && /*#__PURE__*/React.createElement("div", {
      className: cn('container plus_header', qs_o().hide_header && 'invisible')
    }, /*#__PURE__*/React.createElement(Navbar_logo, null)), /*#__PURE__*/React.createElement(Payment, {
      opt: opt,
      only_right_part: only_right_part
    }), /*#__PURE__*/React.createElement(Br_footer, null));
  };
  return E;
});